module.exports = __webpack_public_path__ + "media/emoji_icons/high_disabled-20d3466c.svg";